export default "__VITE_ASSET__DIDZOZxk__"